<template>
  <el-dialog
    :title="isEdit ? $t('subAccount.account.edit') : $t('subAccount.account.add')"
    :visible="visible"
    :close-on-click-modal="false"
    width="520px"
    @close="handleClose"
  >
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      :label-width="$i18n.locale == 'zh' ? '100px' : '150px'"
      label-position="left"
    >
      <el-form-item :label="$t('subAccount.account.email')" prop="email" :required="isEdit">
        <!-- 邮箱即登录名，创建后不可改 -->
        <el-input
          v-model.trim="form.email"
          :disabled="isEdit"
          :placeholder="$t('subAccount.account.emailPh')"
        />
      </el-form-item>

      <el-form-item :label="$t('subAccount.account.name')" prop="name">
        <el-input
          :value="form.name"
          :maxlength="NAME_MAX"
          :placeholder="$t('subAccount.account.namePh')"
          @input="onNameInput"
        />
      </el-form-item>

      <el-form-item :label="$t('subAccount.account.role')" prop="roleId">
        <el-select
          v-model="form.roleId"
          style="width: 100%"
          :placeholder="$t('subAccount.account.rolePh')"
        >
          <el-option
            v-for="role in roles"
            :key="role.id"
            :label="role.name"
            :value="role.id"
          />
        </el-select>
      </el-form-item>
    </el-form>

    <span slot="footer">
      <el-button @click="handleClose">{{ $t('cancel') }}</el-button>
      <el-button type="primary" :loading="saving" @click="submit">{{ $t('confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>

const NAME_MAX = 20

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export default {
  name: 'AccountDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 编辑时传入账号行数据，新建传 null
    account: {
      type: Object,
      default: null
    },
    roles: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      NAME_MAX: NAME_MAX,
      saving: false,
      form: {
        id: null,
        email: '',
        name: '',
        roleId: null
      }
    }
  },
  computed: {
    isEdit() {
      return !!(this.account && this.account.id)
    },
    // 放 computed 里，切换语言时提示文案跟着变
    rules() {
      const t = key => this.$t('subAccount.account.' + key)
      return {
        // 编辑时邮箱禁用，不校验
        email: this.isEdit ? [] : [
          { required: true, message: t('errEmailEmpty'), trigger: 'blur' },
          { pattern: EMAIL_RE, message: t('errEmailFormat'), trigger: 'blur' }
        ],
        name: [{ required: true, whitespace: true, message: t('errNameEmpty'), trigger: 'blur' }],
        roleId: [{ required: true, message: t('errRoleEmpty'), trigger: 'change' }]
      }
    }
  },
  watch: {
    visible(val) {
      if (val) this.reset()
    }
  },
  created() {
    if (this.visible) this.reset()
  },
  methods: {
    reset() {
      const a = this.account
      this.saving = false
      this.form = {
        id: a && a.id ? a.id : null,
        email: a ? a.email || '' : '',
        name: a ? a.account_name || '' : '',
        roleId: a && a.role_id ? a.role_id : null
      }
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },
    // 账号名称超长直接截断
    onNameInput(val) {
      this.form.name = String(val).slice(0, NAME_MAX)
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) this.confirmAndSave()
      })
    },
    confirmAndSave() {
      if (this.isEdit) {
        this.save()
        return
      }
      // 二次确认
      const h = this.$createElement
      this.$confirm('', this.$t('subAccount.account.createTitle'), {
        message: h('div', null, [
          h('p', { style: 'margin:0 0 8px' }, this.$t('subAccount.account.createBody1', { email: this.form.email })),
          h('p', { style: 'margin:0' }, this.$t('subAccount.account.createBody2'))
        ]),
        confirmButtonText: this.$t('subAccount.account.createConfirm'),
        cancelButtonText: this.$t('cancel')
      })
        .then(() => this.save())
        .catch(() => {})
    },
    save() {
      const f = this.form
      const params = f.id
        ? { id: f.id, account_name: f.name, role_id: f.roleId }
        : { email: f.email, account_name: f.name, role_id: f.roleId }
      this.saving = true
      this.__postData('subAccountEdit', params, res => {
        this.saving = false
        if (res && res.code == 1) {
          this.$message.error(res.msg || this.$t('subAccount.account.errEmailExists'))
          return
        }
        if (this.isEdit) {
          this.$message.success(this.$t('subAccount.account.saved'))
        } else {
          this.$message.success(this.$t('subAccount.account.created', { email: f.email }))
        }
        this.$emit('saved')
        this.handleClose()
      }, errmsg => {
        this.saving = false
        this.$message.error(errmsg)
      }).catch(() => {
        this.saving = false
      })
    },
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    }
  }
}
</script>
